import React, { useCallback, memo } from 'react';
import { FuncType } from '../../button/enum';
import { Size } from '../../core/enum';
import Button from '../../button/Button';
import useModal from '../../use-modal';
const CustomizationColumnHeader = memo(function CustomizationColumnHeader(props) {
    const { onHeaderClick } = props;
    const modal = useModal();
    const openCustomizationModal = useCallback(() => onHeaderClick(modal), [modal, onHeaderClick]);
    return (React.createElement(Button, { funcType: FuncType.flat, size: Size.small, icon: "predefine", onClick: openCustomizationModal }));
});
CustomizationColumnHeader.displayName = 'CustomizationColumnHeader';
export default CustomizationColumnHeader;
